import { RegistryContext } from "@effect/atom-react";
import { AsyncResult } from "effect/unstable/reactivity";
import { useContext, useEffect } from "react";
import { toastManager } from "../components/ui/toast";
import { reviewCountsResultAtom } from "./governance";
import { recentLocalReviewWrite, reviewCountNotification, type ReviewCountUpdate } from "./reviewCountNotifications";

/** Observe once per layout without subscribing the React layout to transport updates. */
export function useReviewCountNotifications(organizationId: string | null) {
  const registry = useContext(RegistryContext);
  useEffect(() => {
    if (!organizationId) return;
    let previous: ReviewCountUpdate | null = null;
    return registry.subscribe(reviewCountsResultAtom(organizationId), (result) => {
      if (result.waiting || result._tag !== "Success") return;
      const value = AsyncResult.getOrElse(result, () => null);
      if (!value || "unavailable" in value) return;
      const title = reviewCountNotification(previous, value);
      previous = value;
      // A change this tab just made has its own toast; the push it causes stays quiet.
      if (title && !recentLocalReviewWrite()) toastManager.add({ id: "compliance-review-counts", type: "info", title });
    }, { immediate: true });
  }, [organizationId, registry]);
}
